<div
	[formGroup]="control"
	[ngClass]="{
    'border-neutral-200 dark:border-neutral-700': value.enabled,
    'border-neutral-200 bg-neutral-100 text-gray-500 dark:border-neutral-800 dark:bg-neutral-800 dark:text-gray-400':
      !value.enabled
  }"
	*ngIf="control.value as value"
	class="rounded-lg border"
>
	<div
		[ngClass]="{ 'cursor-pointer': !disabled, 'cursor-not-allowed': disabled }"
		class="grid h-14 select-none grid-cols-[1fr_60px_40px_80px] items-center pl-4"
	>
		<div
			(click)="toggleCard(!value.enabled)"
			class="flex h-full items-center space-x-2"
		>
			<div class="flex flex-col">
				<h1 class="text-md font-bold">{{ now | dfnsAddDays: day | dfnsFormat: 'iiii' }}</h1>
				<div
					*ngIf="stats$ | async as stats"
					class="mat-hint flex space-x-1 text-sm"
				>
					<div>{{ 'reports.total' | translate }}:</div>
					<div>{{ stats.total | parseMsAsDuration }}</div>
				</div>
			</div>
			<ng-container *ngIf="value.name">
				<div class="mat-bg-5 size-1 rounded-full"></div>
				<div class="flex items-center space-x-2">
					<div class="text-neutral-400">{{ value.name }}</div>
				</div>
			</ng-container>
		</div>
		<ng-container *ngTemplateOutlet="!disabled && value.enabled ? createItemView : empty"></ng-container>
		<div
			(click)="toggleCard(!value.enabled)"
			class="flex h-full items-center justify-center"
		>
			<mat-icon>{{ value.enabled ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
		</div>
		<div class="flex items-center justify-center space-x-4">
			<div class="mat-bg-5 h-8 w-px flex-shrink-0"></div>
			<mat-slide-toggle
				[ngClass]="{ 'opacity-80': !value.enabled }"
				formControlName="enabled"
			></mat-slide-toggle>
		</div>
	</div>
	<div
		*ngIf="value.enabled"
		class="mb-4 flex flex-col"
	>
		<div class="mt-2 flex flex-col space-y-2">
			<ng-container
				*ngIf="items.length > 0; else noItems"
				formArrayName="items"
			>
				<ng-container *ngFor="let item of items.controls; let ctrlName = index">
					<ng-container
						*ngTemplateOutlet="editItemView; context: { $implicit: item, name: ctrlName }"
					></ng-container>
				</ng-container>
			</ng-container>
		</div>
	</div>
	<ng-template #noItems>
		<div class="flex h-12 items-center justify-center">{{ 'utils.noitems' | translate }}</div>
	</ng-template>
	<ng-template #createItemView>
		<div class="flex items-center justify-center">
			<button
				(click.native)="onAddTime()"
				[matTooltip]="'utils.addTimeSpan' | translate"
				@expandItems
				class="mat-button-square !rounded-lg"
				mat-button
			>
				<mat-icon>add_circle</mat-icon>
			</button>
		</div>
	</ng-template>
	<ng-template #empty> <div></div> </ng-template>
	<ng-template
		#editItemView
		let-ctrlName="name"
		let-item
	>
		<div
			[formGroup]="item"
			class="mx-4 grid h-12 grid-cols-[1fr_24px_240px_50px] items-center overflow-x-auto"
		>
			<div class="flex items-center justify-end">
				<ng-container *ngIf="getDurationFromItem(item.value) as dur">
					<span [matTooltip]="'timer.time.duration' | translate">{{ dur / 1000 | parseMsAsDuration }}</span>
				</ng-container>
			</div>
			<div></div>
			<div class="flex items-center justify-center space-x-2">
				<div class="flex-auto ">
					<app-time-input
						[displayFormat]="false"
						formControlName="from"
						placeholder="00:00"
					>
						<ng-template
							let-c="control"
							let-inputPlaceholder="inputPlaceholder"
							timeInputControl
						>
							<mat-form-field
								[matTooltip]="inputPlaceholder | translate"
								appearance="fill"
								class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
								fxFill
							>
								<input
									[formControl]="c"
									matInput
									type="text"
								>
							</mat-form-field>
						</ng-template>
					</app-time-input>
				</div>
				<mat-icon
					class="flex-shrink-0"
					inline
				>
					arrow_forward
				</mat-icon>
				<div class="flex-auto pb-0">
					<app-time-input
						[displayFormat]="false"
						formControlName="to"
						placeholder="00:00"
					>
						<ng-template
							let-c="control"
							let-inputPlaceholder="inputPlaceholder"
							timeInputControl
						>
							<mat-form-field
								[matTooltip]="inputPlaceholder | translate"
								appearance="fill"
								class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
								fxFill
							>
								<input
									[formControl]="c"
									matInput
									type="text"
								>
							</mat-form-field>
						</ng-template>
					</app-time-input>
				</div>
			</div>
			<input
				class="hidden"
				formControlName="editing"
				type="hidden"
			>
			<div class="flex items-center justify-end space-x-2">
				<button
					(click)="delItem(ctrlName)"
					[disabled]="disabled"
					[matTooltip]="'utils.delete' | translate"
					class="mat-button-square !rounded-lg"
					color="error"
					mat-button
				>
					<mat-icon>cancel</mat-icon>
				</button>
			</div>
		</div>
	</ng-template>
	<ng-template
		#showItemView
		let-ctrlName="name"
		let-item
	>
		<div class="mx-4 grid h-12 grid-cols-[1fr_24px_240px_100px] items-center overflow-x-auto">
			<span class="min-w-[180px] truncate">{{ item.value.name }}</span>
			<div></div>
			<div class="flex items-center justify-center space-x-2">
				<div
					class="flex h-10 flex-auto items-center justify-center rounded border border-neutral-300 px-3 text-center dark:border-neutral-700"
				>
					{{ parseTimeToDate(item.value.from) | formatDate: 'time' }}
				</div>
				<mat-icon
					class="flex-shrink-0"
					inline
				>
					arrow_forward
				</mat-icon>
				<div
					class="flex h-10 flex-auto items-center justify-center rounded border border-neutral-300 px-3 text-center dark:border-neutral-700"
				>
					{{ parseTimeToDate(item.value.to) | formatDate: 'time' }}
				</div>
			</div>
			<div class="flex items-center justify-end space-x-2">
				<button
					(click)="editItem(ctrlName)"
					[matTooltip]="'utils.edit' | translate"
					class="mat-button-square !rounded-lg"
					mat-button
				>
					<mat-icon>edit</mat-icon>
				</button>
				<button
					(click)="delItem(ctrlName)"
					[matTooltip]="'utils.delete' | translate"
					class="mat-button-square !rounded-lg"
					color="error"
					mat-button
				>
					<mat-icon>cancel</mat-icon>
				</button>
			</div>
		</div>
	</ng-template>
</div>
